module.exports = __webpack_public_path__ + "img/turbo_on.6bada74a.png";